module.exports = __webpack_public_path__ + "static/image-imgn-a5ca7e810b0adf528b57bffaea730fb2.jpg";